import React, { useContext } from 'react';
import { Breadcrumb, BreadcrumbItem, Col, Nav, NavItem, NavLink } from 'reactstrap';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import ProfileDropdown from './ProfileDropdown';
import AppContext from '../../context/Context';

const TopNavRightSideNavItem = () => {
  const { isTopNav, isCombo } = useContext(AppContext);

  const { slug } = useParams();
  const { pathname } = useLocation();
  let history = useHistory();
  const pathnames = pathname.split('/').filter(Boolean);

  const mapObj = {
    bugzero: 'BugZero',
    BugZero: 'BugZero',
    servicenow: 'ServiceNow',
    ServiceNow: 'ServiceNow',
    aws: 'AWS',
    AWS: 'AWS',
    paloalto: 'Palo Alto Networks',
    db: 'DB',
    DB: 'DB',
    msftaccess: 'Microsoft Access',
    msftsql: 'Microsoft SQL Server',
    msftserver: 'Microsoft Windows Server',
    msft: 'Microsoft',
    api: 'API',
    API: 'API',
    PostgreSQL: 'PostgreSQL',
    postgre: 'PostgreSQL',
    app: 'App',
    App: 'App',
    vmware: 'VMware',
    VMware: 'VMware',
    cmdb: 'CMDB',
    CMDB: 'CMDB',
    sso: 'SSO',
    SSO: 'SSO',
    rh: 'Red Hat'
  };

  const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');

  return (
    <Nav navbar className="navbar-nav-icons ml-auto flex-row align-items-center">
      {/* <NotificationDropdown /> */}
      {pathname.length > 1 && (
        <>
          <NavLink onClick={history.goBack}>Back</NavLink>
          <NavItem className="ml-3">|</NavItem>
        </>
      )}

      <Col md="auto" className="mt-4 mt-md-0 mr-4">
        <Breadcrumb>
          {pathnames.map((name, index) => {
            // const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            return isLast ? (
              <BreadcrumbItem key={name + 'key'} className="text-capitalize ml-1" active={true}>
                {name
                  .replace(/-/g, ' ')
                  .replace('sso sn', '')
                  // .replace('postgre', 'PostgreSQL')
                  .replace(re, function(matched) {
                    return mapObj[matched];
                  })}
              </BreadcrumbItem>
            ) : (
              // <Link to={routeTo} key={name + 'key'}>
              <BreadcrumbItem key={name} className="text-capitalize ml-1">
                {name
                  .replace(/-/g, ' ')
                  .replace('sso sn', '')
                  // .replace('postgre', 'PostgreSQL')
                  .replace(re, function(matched) {
                    return mapObj[matched];
                  })}
              </BreadcrumbItem>
              // </Link>
            );
          })}
        </Breadcrumb>
      </Col>
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
